module.exports = __webpack_public_path__ + "static/media/ig20.dbc1349b.jpg";